import { ScreenSequence, ScreenConfig } from "../Sequences";
import { NudgingScreen1 } from "./NudgingScreen1";
import { NudgingScreen2 } from "./NudgingScreen2";
import { NudgingScreen3 } from "./NudgingScreen3";
import { NudgingScreen4 } from "./NudgingScreen4";
import { ResultScreen1 } from "./ResultScreen1";
import { ResultScreen2 } from "./ResultScreen2";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { ExplainationScreen } from "./ExplanationScreen";
import { useSession } from "../../../SessionContext";
import { useLanguage } from "../../../../context/LanguageContext";

export const NudgingKey = "Nudging";

export function useNudgingSequence(): ScreenSequence {
    const { userData, writeUserData } = useSession();
    const { t } = useLanguage();

    // Use randomizer2 for between-subjects condition (default: "Bedingung 1")
    let randomizer2 = userData?.randomizer2;
    if (!randomizer2) {
        randomizer2 = Math.random() < 0.5 ? "Bedingung 1" : "Bedingung 2";
        writeUserData({
            ...userData,
            randomizer2,
        });
    }

    // Bedingung 1: Muesli good (NutriScore B) + TV bad (label D)
    // Bedingung 2: Muesli bad (NutriScore D) + TV good (label A+)
    const screens: ScreenConfig[] = [
        randomizer2 === "Bedingung 2"
            ? { component: NudgingScreen2 }
            : { component: NudgingScreen1 },

        randomizer2 === "Bedingung 2"
            ? { component: NudgingScreen3 }
            : { component: NudgingScreen4 },

        { component: ResultScreen1 },
        { component: ResultScreen2 },      // Add the new TV result screen
        { component: ExplainationScreen },
        {
            component: WellDoneScreen,
            canContinueDefault: false,
        }
    ];

    return {
        name: t('experiments', 'nudge', 'title') || "Institutionelles Nudging: NutriScore & Energie-Label",
        description: t('experiments', 'nudge', 'description') || "",
        group: "A3",
        screens,
        resultScreenIndex: 2,
        explanationScreenIndex: 4,
    };
}